var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row"},_vm._l((_vm.breadcrumbs),function(link,index){return _c('router-link',{key:link.to,attrs:{"to":link.to}},[_c('div',{staticClass:"flex flex-row"},[(index !== 0)?_c('p',{class:{
          'text-sm': true,
          'px-2': true,
          'active-breadcrumb': _vm.activeBreadcrumb(index),
          'inactive-breadcrumb': _vm.inactiveBreadcrumb(index)
        },staticStyle:{"font-family":"'Source Sans Pro'"}},[_vm._v(" / ")]):_vm._e(),(link.icon)?_c('vs-icon',{attrs:{"icon":link.icon}}):_vm._e(),_c('p',{class:{
          'text-sm': true,
          'active-breadcrumb': _vm.activeBreadcrumb(index),
          'inactive-breadcrumb': _vm.inactiveBreadcrumb(index)
        }},[_vm._v(" "+_vm._s(link.title)+" ")])],1)])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }